import { UserState } from '../dashboard/content-header/content-header.component'
import { NavigationBarState } from '../../lib/navigationbar/navigationbar.component'
import { PerformanceNavigation } from '../../lib/performance/performance.component'
import { ContentTile, SearchState } from '@nx-superprep/shared'
import { LibraryNavigation, NavigationState, PopDataType, _defaultCharts, _defaultStats, randomizeStat } from '@nx-superprep/backend/firebase'
import { LessonTile } from '@nx-superprep/study'
import { DateOnly, distantPast } from '@nx-superprep/utils'
import { CompletionState } from '../home/status/completion-state'
import { LibraryContent } from '../library/explore/explore.component'
import { LessonTerm } from '../drawer/drawer-content/lesson-terms/lesson-terms.component'
import { DrawerState } from '../drawer'

export const _defaultBrand = `/assets/img/brand/brand@3x.webp`

export const _defaultCompletionState: CompletionState = { activeDate: new DateOnly(), selected: 'today', estimated: 0, completed: { today: 0, overall: 0 }}

export const randomizeTerms = ():LessonTerm[] => {
  return Array(12).fill(1).map((v,i) => ({name: 'Term '+i, translation: 'translation '+i, progress: Math.floor(12*Math.random()), count: Math.ceil(12*Math.random())}))
}

export const _defaultTerms = randomizeTerms()

export const getTiles = (args: {
  count?: number,
  type?: 'collection'|'level'|'grade'|'subject'|'lesson'|'empty',
  progress?: number
} = {count: 12, type: 'lesson', progress: 0.5}): ContentTile[] | LessonTile[] => {
  return args.type === 'empty'
  ? []
  : Array(args.count ?? 12).fill(1).map((_v, i) => ({
    itemId: '',
    dataType: PopDataType.ModuleTemplate,
    title: (() => {
      switch(args.type ?? 'lesson') {
        case 'collection': return ['picks', 'knowledge', 'new'][Math.floor(3 * Math.random())]
        case 'level': return ['Travel', 'Food & Drink', 'In Town', 'Days, Month & Seasons'][Math.floor(4 * Math.random())]
        case 'subject': return ['Chemistry', 'Chinese', 'French', 'Spanish', 'Biology'][Math.floor(5 * Math.random())]
        default: return 'Unit '+i.toString()
      }
    })(),
    subTitle:[
      'Master the words and vocabulary for the HSK Exam',
      'Discover Chinese! Master all essential vocabulary corresponding to HSK Level',
      'Build your Chinese vocabulary with all the characters in HSK Level',
      'Expand your Chinese vocabulary with the second part of HSK Level',
      'Grow your Chinese vocabulary with the first part of HSK Level',
    ][Math.floor(5 * Math.random())],
    iconName: '/assets/images/' + [
      'hsk1','hsk2','hsk3-1',
      'image2','image3','image4','image5',
      'chinese1','chinese2','chinese3','chinese-high-3',
      'travel-sml', 'food-sml', 'time'
    ][Math.floor(14 * Math.random())] + '.png',
    progress: (args.progress ?? 0.5) > 0 ? (args.progress ?? 0.5) < 1 ? Math.random() : (args.progress ?? 0.5) : (args.progress ?? 0.5),
    stats: randomizeStat(),
    terms: _defaultTerms,
    color: [
      '#EB9BBD','#F0EBAB','#C7E38D','#978BC4','#83B3E0',
      '#645CBB','#A084DC','#BFACE2','#EBC7E6',
    ][Math.floor(9 * Math.random())],
    }))
}

export const _defaultLibraryContent: LibraryContent[] = [
  {
    title: 'Subjects',
    items: [],
    tiles: getTiles({count: 12, type:'subject'})
  },
  {
    title: 'Top Picks For You',
    subTitle: 'Continue your learning.',
    items: [],
    tiles: [
      {image: '/assets/images/travel-sml.png', title:'Travel', color:'bisque'},
      {image: '/assets/images/food-sml.png', title:'Food & Drink', color:'burlywood'},
      {image: '/assets/images/time.png', title:'In Town', color:'darkorange'},
      {image: '/assets/images/time.png', title:'Days, Months & Seasons', color:'mediumpurple'},
      {image: '/assets/images/travel-sml.png', title:'Travel', color:'bisque'},
      {image: '/assets/images/food-sml.png', title:'Food & Drink', color:'burlywood'},
      {image: '/assets/images/time.png', title:'In Town', color:'darkorange'},
      {image: '/assets/images/time.png', title:'Days, Months & Seasons', color:'mediumpurple'},
    ] as ContentTile[],
  }, {
    title: 'Expand your Knowledge',
    subTitle: 'You may also enjoy these subjects.',
    items: [],
    tiles: [
      {image: '/assets/images/chinese1.png', title:'Chinese', color:'burlywood'},
      {image: '/assets/images/chinese2.png', title:'Chinese', color:'mediumpurple'},
      {image: '/assets/images/chinese3.png', title:'Chinese', color:'azure'},
      {image: '/assets/images/chinese-high-3.png', title:'French', color:'beige'},
      {image: '/assets/images/chinese1.png', title:'Chinese', color:'burlywood'},
      {image: '/assets/images/chinese2.png', title:'Chinese', color:'mediumpurple'},
      {image: '/assets/images/chinese3.png', title:'Chinese', color:'azure'},
      {image: '/assets/images/chinese-high-3.png', title:'French', color:'beige'},
    ] as ContentTile[]
  }, {
    title: 'Try Something New',
    subTitle: 'Some of our favorites',
    items: [],
    tiles: [
      {image: '/assets/images/chinese1.png', title:'Chinese', color:'beige'},
      {image: '/assets/images/chinese2.png', title:'Chinese', color:'azure'},
      {image: '/assets/images/chinese3.png', title:'Chinese', color:'cadetnlue'},
      {image: '/assets/images/chinese-high-3.png', title:'French', color:'wheat'},
      {image: '/assets/images/chinese1.png', title:'Chinese', color:'beige'},
      {image: '/assets/images/chinese2.png', title:'Chinese', color:'azure'},
      {image: '/assets/images/chinese3.png', title:'Chinese', color:'cadetnlue'},
      {image: '/assets/images/chinese-high-3.png', title:'French', color:'wheat'},
    ] as ContentTile[]
  }

]

export const _defaultLesson: LessonTile = getTiles()[Math.floor(12 * Math.random())] as LessonTile
export const _defaultGroup: ContentTile = getTiles()[Math.floor(12 * Math.random())] as ContentTile
export const _defaultSubject: ContentTile = getTiles()[Math.floor(12 * Math.random())] as ContentTile

export const _defaultDrawerContentTabs = [
  {label:'Active', title: 'Your Units', subtitle: 'Completed 35 mins'},
  {label:'Done', title: 'Your Units', subtitle: 'Today\'s study 35 mins'},
]

export const _defaultDrawerStates = (value: 'empty'|'dayplan-lessons'|'library-lessons'|'lesson-completion'|'performance-stats'|'performance-charts'): DrawerState => {
  switch(value) {
    case 'empty': return {
      type: 'dayplan-lessons', headerState: { activeTab: 'all', tabs: [ { label: 'All', disabled:true } ] }, contentState: { date: new DateOnly(), tiles: getTiles({type:'empty'}), selected: undefined }
    }
    case 'dayplan-lessons': return {
      type: value, headerState: { activeTab: 'Active', tabs: _defaultDrawerContentTabs, }, contentState: { date: new DateOnly(), tiles: getTiles(), }
    }
    case 'library-lessons': return {
      type: value, headerState: { activeTab: 'Active', tabs: _defaultDrawerContentTabs, }, contentState: { date: new DateOnly(), tiles: getTiles(), }
    }
    case 'lesson-completion': return {
      type: value, headerState: {}, contentState: { date: new DateOnly(), lesson: _defaultLesson }
    }
    case 'performance-stats': return {
      type: value, headerState: { activeTab: 'today', tabs: [ { label: 'Today' }, { label: 'Overall' } ]}, contentState: { date: new DateOnly(distantPast), tiles: getTiles({type: 'empty'}), selected: undefined, stats: _defaultStats(true) }
    }
    case 'performance-charts': return {
      type: value, headerState: { activeTab: 'week', tabs: [ { label:'Week' }, { label:'Month' }, { label:'Year' } ] }, contentState: { date: new DateOnly(distantPast), tiles: getTiles({type: 'empty'}), selected: undefined, charts: _defaultCharts(undefined, true) }
    }
  }
}

export const _defaultSearch: SearchState = {
  keywords: [],
  placeholder: 'Search...',
  visible: false,
}

export const _defaultUser: UserState = { greeting: 'Hello,', name: 'Jamie', avatar: { src: '/assets/images/avatar-ellipse.png', alt: 'Avatar-ellipse' }}
export const _defaultNavigation: NavigationState = { current: { route: 'home', type: 'root' }}
export const _defaultNavigationState: NavigationBarState = { ..._defaultNavigation, title: 'Home' }
export const _defaultTabState: LibraryNavigation|PerformanceNavigation = { navigation: _defaultNavigation}
export const _defaultImageURL = '/assets/missing.svg'
